import { useParams } from 'react-router-dom';
import useCampaign from '../../hooks/useCampaign';
import Back from '../Back';
import IterationPageHeader from '../IterationPageHeader';

interface RuleLibraryHeaderProps {
  ruleType?: string;
}

export default function RuleLibraryHeader({ ruleType = 'Rule library' }: RuleLibraryHeaderProps) {
  const { iterationId, teamId, campaignId } = useParams();
  const { campaign } = useCampaign();

  const thisIteration = campaign.CampaignConfig.Iterations?.find(
    (iteration: { ID?: string; IterationCohorts?: unknown[] }) => iteration.ID === iterationId,
  );
  return (
    <>
      <div className="nhsuk-u-margin-bottom-6">
        <Back label="Iteration summary" backTo={`/${teamId}/campaign/${campaignId}/iteration/${iterationId}/summary`} />
      </div>
      {thisIteration && (
        <IterationPageHeader iteration={thisIteration} title={ruleType} />
      )}
    </>
  );
}
